import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { Grid } from '@material-ui/core';
import FormContainer from './styles';
import { Button } from '../../../../../components/Buttons';
import { useTranslation } from 'react-i18next';
import TextField from '../../../../../components/TextField';
import CheckboxField from '../../../../../components/Checkbox';
import CustomSnackbar from '../../../../../components/Snackbar';

const ContactForm = () => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [severity, setSeverity] = useState('');
	const [message, setMessage] = useState('');

	const sendEmail = async (values, { setSubmitting, resetForm }) => {
		setSubmitting(false);

		let response = await fetch(process.env.REACT_APP_EMAIL_URL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Token ${process.env.REACT_APP_EMAIL_TOKEN}`
			},
			mode: 'cors',
			body: JSON.stringify({
				sender: values.name,
				sender_email: process.env.REACT_APP_EMAIL_SENDER,
				recipients: [process.env.REACT_APP_EMAIL_RECIPIENT],
				subject: 'Contacto',
				template_name: 'medicina-fetal-barcelona',
				template_params: {
					header: 'Nuevo mensaje',
					body: `<p>Email de ${values.name} (${values.email}) </p>
					<p>${t('general.contact.fields.phone')}: ${values.phone}</p>
					<p>${t('general.contact.fields.country')}: ${values.country}</p>
					<p>${values.message}</p>
					<p>${t('general.contact.fields.newsletter')}: ${values.newslatter ? 'Si' : 'No'}</p>
					`
				},
				reply_to: [values.email]
			})
		});

		if (response.ok) {
			setSubmitting(true);
			resetForm();
			setOpen(true);
			setSeverity('success');
			setMessage(t('general.contact.messageSuccess'));
		} else {
			setOpen(true);
			setSeverity('error');
			setMessage(t('general.contact.messageError'));
		}
	};

	return (
		<FormContainer>
			<Formik
				initialValues={{
					name: '',
					email: '',
					country: '',
					phone: '',
					message: '',
					newslatter: false
				}}
				validate={values => {
					const errors = {};
					if (!values.name) {
						errors.name = t('general.contact.errors.name');
					} else if (!values.country) {
						errors.country = t('general.contact.errors.country');
					} else if (!values.email) {
						errors.email = 'Required';
					} else if (
						!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
					) {
						errors.email = t('general.contact.errors.invalidEmail');
					} else if (!values.phone) {
						errors.phone = t('general.contact.errors.phone');
					} else if (!values.message) {
						errors.message = t('general.contact.errors.message');
					}
					return errors;
				}}
				onSubmit={sendEmail}
			>
				{({ isSubmitting, errors, touched }) => (
					<Form>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<TextField
									name="name"
									label={t('general.contact.fields.name')}
									errors={errors}
									touched={touched}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									name="country"
									label={t('general.contact.fields.country')}
									errors={errors}
									touched={touched}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									name="email"
									label={t('general.contact.fields.email')}
									type="email"
									errors={errors}
									touched={touched}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									name="phone"
									label={t('general.contact.fields.phone')}
									errors={errors}
									touched={touched}
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									name="message"
									label={t('general.contact.fields.message')}
									multiline={true}
									rows={4}
									errors={errors}
									touched={touched}
								/>
							</Grid>
							<Grid item xs={12}>
								<CheckboxField
									name="newslatter"
									label={t('general.contact.fields.newsletter')}
									errors={errors}
									touched={touched}
								/>
							</Grid>
						</Grid>

						<Button
							variant={'contained'}
							disabled={isSubmitting}
							color={'primary'}
							type="submit"
							content={t('general.actions.send')}
						/>
					</Form>
				)}
			</Formik>
			<CustomSnackbar
				open={open}
				severity={severity}
				message={message}
				onClose={() => setOpen(false)}
			/>
			;
		</FormContainer>
	);
};

export default ContactForm;
